<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/admin/organization-listing']">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/admin/organization-listing']">Organizations</a>
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <div *ngIf="isLoaded">
            <form novalidate [formGroup]="orgEditForm" (ngSubmit)="doSave()">
                <my-tabs>
                    <my-tab [tabTitle]="'From CRM'">
                        <div class="form-wrapper-80">
                            <h2>CRM Fields</h2>
                            <div>
                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Sugar ID</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.sugar_id_c"
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Sugar Account Name</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.sugar_name"
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Welltrack Connect Account Id</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.connect_account_id_c"
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Welltrack Boost Status</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.boost_status_c"
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Welltrack Connect Status</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.connect_status_c"
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Assigned to RM User</label>
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="organization?.crmGroup?.assigned_user_name"
                                        readonly
                                        type="text" />
                                </div>
                            </div>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Basic Details'">
                        <div class="form-wrapper-80">
                            <h2>Basic Details</h2>
                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="organizationName">Display Name</label>
                                <img
                                    alt="Full name"
                                    *ngIf="fullName"
                                    src="./assets/img/icons/check@2x.png"
                                    class="check animated fadeInUp"
                                    item-content />
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="name"
                                    id="organizationName" />
                                <div class="error-message"
                                    *ngIf="f.name.touched && f.name.errors?.required">
                                    The organization needs a name.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="serviceType" translate>Service Type</label>
                                <select class="app-c-form-control" formControlName="ServiceType" id="serviceType">
                                    <option [ngValue]="null">None</option>
                                    <option *ngFor="let service of serviceType" [ngValue]="service.id">
                                        {{ service.name }}
                                    </option>
                                </select>
                                <div class="error-message"
                                    *ngIf="f.ServiceType.touched && f.ServiceType.errors?.required">
                                    The organization needs a service type.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="serviceTier" translate>Service Tier</label>
                                <select class="app-c-form-control" formControlName="ServiceTier" id="serviceTier">
                                    <option [ngValue]="null">None</option>
                                    <option *ngFor="let service of serviceTier" [ngValue]="service.name">
                                        {{ service.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="parentId" translate>Parent Org</label>
                                <select
                                    class="app-c-form-control"
                                    formControlName="parentOrgId"
                                    id="parentId"
                                    [attr.disabled]="organization.childOrganizations ? true : null">
                                    <option [ngValue]="null">None</option>
                                    <option *ngFor="let org of organizations" [ngValue]="org.id">
                                        {{ org.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="app-c-form-group number-field">
                                <label class="app-c-form--label" for="eligiblePopulation">Eligible Population</label>
                                <input
                                    class="app-c-form-control"
                                    type="number"
                                    min="0"
                                    formControlName="eligiblePopulation"
                                    id="eligiblePopulation" />
                                <div class="error-message"
                                    *ngIf="f.eligiblePopulation.touched && !f.eligiblePopulation.valid">
                                    Invalid count.
                                </div>
                            </div>

                            <div class="icon-input">
                                <input
                                    type="checkbox"
                                    formControlName="demoStatus"
                                    id="demoStatus" />
                                <label for="demoStatus" translate>Demo/Trial</label>
                            </div>

                            <div class="icon-input">
                                <input
                                    type="checkbox"
                                    formControlName="active"
                                    id="active" />
                                <label for="active">Active</label>
                            </div>

                            <div>
                                <img
                                    [alt]="organization.name"
                                    *ngIf="organization.logoPath"
                                    [src]="organization.logoPath"
                                    style="max-width: 300px; max-height: 200px; height: auto;" />
                            </div>

                            <div class="icon-input">
                                <label for="logo">Logo</label>
                                <input
                                    type="file"
                                    (change)="changeListener($event)"
                                    #input />
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Address</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="address"
                                    id="address" />
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Phone</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="phone"
                                    id="phone"
                                    placeholder="(xxx) xxx-xxxx / xxx-xxxx,,x,,x,x" />
                                <div class="error-message"
                                    *ngIf="f.phone.touched && !f.phone.valid">
                                    Invalid phone number.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Website</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="website"
                                    id="website" />
                                <div class="error-message"
                                    *ngIf="f.website.touched && !f.website.valid">
                                    Invalid url
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Protocall account reference ID</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="protocallRefId"
                                    id="protocallRefId" />
                            </div>

                            <div class="icon-input">
                                <label for="emergencyContact" translate>Emergency Contact</label>
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="emergencyContact"
                                    [config]="config"
                                    id="emergencyContact">
                                </ckeditor>
                            </div>

                            <div class="icon-input">
                                <label for="description" translate>Description</label>
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="description"
                                    [config]="config"
                                    id="description"></ckeditor>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Protocall Helpline'">
                        <div class="form-wrapper-80">
                            <div id="protocall-helpline" formGroupName="contactGroup">
                                <h2>Protocall Helpline</h2>
                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" for="protocallTelephone">Phone number</label>
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="telephone"
                                        id="protocallTelephone"
                                        placeholder="(xxx) xxx-xxxx / xxx-xxxx,,x,,x,x" />
                                    <div class="error-message"
                                        *ngIf="contactGroup.controls['telephone'].touched && !contactGroup.controls['telephone'].valid">
                                        Invalid emergency contact phone number.
                                    </div>
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" for="protocallTitle">Title</label>
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="title"
                                        id="protocallTitle" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" for="protocallDescription">Description</label>
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="description"
                                        id="protocallDescription" />
                                </div>

                                <div class="icon-input">
                                    <label for="description" translate>Get Help Now Description</label>
                                    <ckeditor
                                        [editor]="Editor"
                                        formControlName="getHelpDescription"
                                        [config]="config"
                                        id="description">
                                    </ckeditor>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Config'">
                        <div class="config-container">
                            <div class="config-block">
                                <div class="title-conatiner">
                                    <span class="title">Series</span>
                                </div>
                                <h3 class="sub-title-series">Video Series</h3>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="courses">
                                    <div id="coursesSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="let course of courseList.controls; let i = index"
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                id="course-{{ i }}"
                                                formControlName="enabled" />
                                            <label for="course-{{ i }}">{{
                                                course.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>

                                <h3 class="sub-title-series">Stories</h3>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="storiesConfig">
                                    <div id="coursesSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="let story of storyList.controls; let k = index"
                                            [formGroupName]="k">
                                            <input
                                                type="checkbox"
                                                id="story-{{ k }}"
                                                formControlName="enabled" />
                                            <label for="story-{{ k }}">{{
                                                story.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>

                                <h3 class="sub-title-series">Burning Questions</h3>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="burningQuestionsConfig">
                                    <div id="coursesSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="let burningQuestion of burningQuestionList.controls; let k = index"
                                            [formGroupName]="k">
                                            <input
                                                type="checkbox"
                                                id="burningQuestion-{{ k }}"
                                                formControlName="enabled" />
                                            <label for="burningQuestion-{{ k }}">{{
                                                burningQuestion.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>

                                <h3 class="sub-title-series">Daily Series</h3>
                                <div class="form-wrapper-80 content-container">
                                    <div class="icon-input">
                                        <input
                                            type="checkbox"
                                            formControlName="enableDailySeries"
                                            id="enableDailySeries" />
                                        <label for="enableDailySeries">Daily Boost</label>
                                    </div>
                                </div>
                                <h3 class="sub-title-series">Reads</h3>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="readsConfig">
                                    <div id="coursesSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="
                                                let read of readsList.controls;
                                                let k = index
                                            "
                                            [formGroupName]="k">
                                            <mat-checkbox
                                                id="read-{{ k }}"
                                                formControlName="enabled"
                                                class="course">
                                            </mat-checkbox>
                                            <label for="read-{{ k }}">{{
                                                read.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="config-block">
                                <div class="title-conatiner">
                                    <span class="title">Enabled Assessment</span>
                                </div>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="assessmentConfig">
                                    <div id="assessmentSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="let assessment of assessmentList.controls; let i = index"
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                [disabled]="['mentalwellbeing'].includes(assessment.value.key)"
                                                id="assessment-{{ i }}"
                                                formControlName="enabled" />
                                            <label translate for="assessment-{{ i }}">{{
                                                assessment.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="config-block">
                                <div class="title-conatiner">
                                    <span class="title">Enabled Tools</span>
                                </div>
                                <div
                                    class="form-wrapper-80 content-container"
                                    formGroupName="toolsConfig">
                                    <div id="toolSection">
                                        <div
                                            class="check-box-container"
                                            *ngFor="let tool of toolsList.controls; let i = index"
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                id="tool-{{ i }}"
                                                formControlName="enabled" />
                                            <label translate for="tool-{{ i }}">{{
                                                tool.value.name
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Settings'">
                        <div class="form-wrapper-80">
                            <div id="settingsSection" formGroupName="settings">
                                <h2>Settings</h2>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" for="assessment">Type of assessment</label>
                                    <select
                                        class="app-c-form-control"
                                        name="assessment"
                                        formControlName="assessment"
                                        id="assessment">
                                        <option [ngValue]="'das'">DASS</option>
                                    </select>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasCounselors"
                                        id="hasCounselors" />
                                    <label for="hasCounselors">{{
                                        this.customOrgTextKey
                                            ? 'Enable sync with CYFD Worker and invite to share?'
                                            : ('Enable sync with counselor and invite to share?' | translate)
                                    }}</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableAlerts"
                                        id="enableAlerts" />
                                    <label for="enableAlerts">Enable general DASS alerts for individual to synced counselor</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasAssessmentAlerts"
                                        id="hasAssessmentAlerts" />
                                    <label for="hasAssessmentAlerts">Enable HIGH DASS alerts to org admin</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="disableFeedbackSurveys"
                                        id="disableFeedbackSurveys" />
                                    <label for="disableFeedbackSurveys">Disable user feedback surveys?</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hideNotes"
                                        id="hideNotes" />
                                    <label for="hideNotes">Hide notes (disable text fields: e.g. moodcheck notes, thought diary)?</label>
                                </div>

                                <div class="icon-input">
                                    <label for="website">Custom validation checkbox (Enter text or leave blank to disable)</label>
                                    <ckeditor
                                        [editor]="Editor"
                                        formControlName="customConfirm"
                                        id="customConfirm"
                                        [config]="config">
                                    </ckeditor>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasScheduledPushNotification"
                                        id="hasScheduledPushNotification" />
                                    <label for="hasScheduledPushNotification">Enable Scheduled Push Notifications</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="showWelltrackConnect"
                                        id="showWelltrackConnect" />
                                    <label for="showWelltrackConnect">Show link to WellTrack Connect in series</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableAnnouncements"
                                        id="enableAnnouncements" />
                                    <label for="enableAnnouncements">Enable Custom Announcements</label>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Signin Details'">
                        <div class="form-wrapper-80">
                            <div id="sso">
                                <h2 class="form-section-title">Signin Details</h2>

                                <p class="form-help-text">
                                    The subdomain provides a link in the form of
                                    https://subdomain.welltrack-boost.com. This
                                    is used for displaying the org logo.
                                </p>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" translate>Subdomain</label>
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="subdomain"
                                        id="subdomain" />
                                    <div class="error-message"
                                        *ngIf="f.subdomain.touched && f.subdomain.errors?.required">
                                        The organization needs a subdomain.
                                    </div>
                                    <div class="error-message"
                                        *ngIf="f.subdomain.touched && !f.subdomain.errors?.required && !f.subdomain.valid">
                                        Invalid url
                                    </div>
                                </div>

                                <p class="form-help-text">
                                    Users will be automatically associated to
                                    the organization using one of the listed
                                    domains below. If there are multiple
                                    domains, provide them in a comma delimited
                                    list (domain1.org, domain2.org).
                                </p>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" for="allowedDomains" translate>Known Domains</label>
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="allowedDomains"
                                        id="allowedDomains" />
                                </div>

                                <p class="form-help-text">
                                    The enforce domain setting will force users
                                    to use their organization email for
                                    association.
                                </p>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enforceDomains"
                                        id="enforceDomains" />
                                    <label for="enforceDomains" translate>Enforce Domain(s)</label>
                                </div>

                                <p class="form-help-text">
                                    If SSO is setup, provide the details below.
                                </p>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableSso"
                                        id="enableSaml2" />
                                    <label for="enableSaml2">Enable SSO</label>
                                </div>

                                <div class="sso-config-section" *ngIf="orgEditForm.get('enableSso').value">
                                    <div formGroupName="auth">
                                        <p class="form-help-text">
                                            Provide the Identity Provider Entity ID for SSO configuration.
                                        </p>

                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label" for="idp-entity-id">Idp Entity ID</label>
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="idpEntityId"
                                                id="idp-entity-id" />
                                        </div>
                                    </div>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            auth.controls['idpEntityId'].touched &&
                                            auth.controls['idpEntityId'].value === ''
                                        ">
                                        The organization has SSO enabled but no
                                        Entity ID is specified. Disable SSO
                                        until an Entity ID can be saved.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Resources'">
                        <resources-edit
                            [resources]="organization"
                            (onResourceSetChange)="resourceSetChanged($event)">
                        </resources-edit>
                    </my-tab>

                    <my-tab [tabTitle]="'Integration(s)'">
                        <div class="form-wrapper-80" formGroupName="integrations">
                            <div class="app-c-form-group">
                                <label class="app-c-form--label">TogetherAll sso login link</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="togetherAllSsoLink" />
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Tenant(s)'">
                        <div class="form-wrapper-80" formGroupName="tenants">
                            <div
                                class="tenant-item"
                                *ngFor="let tenant of tenantList.controls; let i = index"
                                [formGroupName]="i">
                                <label class="toggle-switch">
                                    <input type="checkbox" formControlName="enabled" />
                                    <span class="toggle-slider"></span>
                                </label>
                                <span class="toggle-label">{{ tenant.value.name }}</span>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Branding'">
                        <div class="form-wrapper-80" formGroupName="brandingGroup">
                            <p>
                                This is designated for the purposes of
                                configuring a customized client branding page
                                which will consist of a leaderboard image, a
                                client logo (different from the one already
                                uploaded), and a description.
                            </p>

                            <div *ngIf="organization.brandingGroup?.brandingClientLogo">
                                <img
                                    [alt]="organization.name"
                                    [src]="organization.brandingGroup?.brandingClientLogo"
                                    style="max-width: 300px; max-height: 200px; height: auto;" />
                            </div>
                            <div class="icon-input">
                                <label for="clientLogo">Client Logo</label>
                                <input
                                    type="file"
                                    (change)="brandingUpload($event, 'clientLogo')"
                                    #input />
                            </div>

                            <div *ngIf="organization.brandingGroup?.brandingCoverPhoto">
                                <img
                                    [alt]="organization.name"
                                    [src]="organization.brandingGroup?.brandingCoverPhoto"
                                    style="max-width: 300px; max-height: 200px; height: auto;" />
                            </div>
                            <div class="icon-input">
                                <label for="coverStylePhoto">Cover Style Photo</label>
                                <input
                                    type="file"
                                    (change)="brandingUpload($event, 'coverPhoto')"
                                    #input />
                            </div>

                            <div class="icon-input">
                                <label for="description" translate>Description</label>
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="brandingDescription"
                                    [config]="config"
                                    id="description">
                                </ckeditor>
                            </div>
                        </div>
                    </my-tab>
                </my-tabs>

                <div class="fixed-footer">
                    <div class="form-wrapper-80">
                        <div class="validation-banner" *ngIf="errors">
                            {{ errors }}
                        </div>
                        <button tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
